/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  EntryPoint,
  EntryPointInterface,
} from "../../../contracts/core/EntryPoint";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "preOpGas",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "paid",
        type: "uint256",
      },
      {
        internalType: "uint48",
        name: "validAfter",
        type: "uint48",
      },
      {
        internalType: "uint48",
        name: "validUntil",
        type: "uint48",
      },
      {
        internalType: "bool",
        name: "targetSuccess",
        type: "bool",
      },
      {
        internalType: "bytes",
        name: "targetResult",
        type: "bytes",
      },
    ],
    name: "ExecutionResult",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "opIndex",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "reason",
        type: "string",
      },
    ],
    name: "FailedOp",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "SenderAddressResult",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "aggregator",
        type: "address",
      },
    ],
    name: "SignatureValidationFailed",
    type: "error",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "preOpGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "prefund",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "sigFailed",
            type: "bool",
          },
          {
            internalType: "uint48",
            name: "validAfter",
            type: "uint48",
          },
          {
            internalType: "uint48",
            name: "validUntil",
            type: "uint48",
          },
          {
            internalType: "bytes",
            name: "paymasterContext",
            type: "bytes",
          },
        ],
        internalType: "struct IEntryPoint.ReturnInfo",
        name: "returnInfo",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "stake",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "unstakeDelaySec",
            type: "uint256",
          },
        ],
        internalType: "struct IStakeManager.StakeInfo",
        name: "senderInfo",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "stake",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "unstakeDelaySec",
            type: "uint256",
          },
        ],
        internalType: "struct IStakeManager.StakeInfo",
        name: "factoryInfo",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "stake",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "unstakeDelaySec",
            type: "uint256",
          },
        ],
        internalType: "struct IStakeManager.StakeInfo",
        name: "paymasterInfo",
        type: "tuple",
      },
    ],
    name: "ValidationResult",
    type: "error",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "preOpGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "prefund",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "sigFailed",
            type: "bool",
          },
          {
            internalType: "uint48",
            name: "validAfter",
            type: "uint48",
          },
          {
            internalType: "uint48",
            name: "validUntil",
            type: "uint48",
          },
          {
            internalType: "bytes",
            name: "paymasterContext",
            type: "bytes",
          },
        ],
        internalType: "struct IEntryPoint.ReturnInfo",
        name: "returnInfo",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "stake",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "unstakeDelaySec",
            type: "uint256",
          },
        ],
        internalType: "struct IStakeManager.StakeInfo",
        name: "senderInfo",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "stake",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "unstakeDelaySec",
            type: "uint256",
          },
        ],
        internalType: "struct IStakeManager.StakeInfo",
        name: "factoryInfo",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "stake",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "unstakeDelaySec",
            type: "uint256",
          },
        ],
        internalType: "struct IStakeManager.StakeInfo",
        name: "paymasterInfo",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "aggregator",
            type: "address",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "stake",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "unstakeDelaySec",
                type: "uint256",
              },
            ],
            internalType: "struct IStakeManager.StakeInfo",
            name: "stakeInfo",
            type: "tuple",
          },
        ],
        internalType: "struct IEntryPoint.AggregatorStakeInfo",
        name: "aggregatorInfo",
        type: "tuple",
      },
    ],
    name: "ValidationResultWithAggregation",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "userOpHash",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "factory",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "paymaster",
        type: "address",
      },
    ],
    name: "AccountDeployed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "BeforeExecution",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalDeposit",
        type: "uint256",
      },
    ],
    name: "Deposited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "aggregator",
        type: "address",
      },
    ],
    name: "SignatureAggregatorChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalStaked",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "unstakeDelaySec",
        type: "uint256",
      },
    ],
    name: "StakeLocked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "withdrawTime",
        type: "uint256",
      },
    ],
    name: "StakeUnlocked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "withdrawAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "StakeWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "userOpHash",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "paymaster",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "success",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "actualGasCost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "actualGasUsed",
        type: "uint256",
      },
    ],
    name: "UserOperationEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "userOpHash",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "revertReason",
        type: "bytes",
      },
    ],
    name: "UserOperationRevertReason",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "withdrawAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Withdrawn",
    type: "event",
  },
  {
    inputs: [],
    name: "SIG_VALIDATION_FAILED",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "initCode",
        type: "bytes",
      },
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "paymasterAndData",
        type: "bytes",
      },
    ],
    name: "_validateSenderAndPaymaster",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "unstakeDelaySec",
        type: "uint32",
      },
    ],
    name: "addStake",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "depositTo",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "deposits",
    outputs: [
      {
        internalType: "uint112",
        name: "deposit",
        type: "uint112",
      },
      {
        internalType: "bool",
        name: "staked",
        type: "bool",
      },
      {
        internalType: "uint112",
        name: "stake",
        type: "uint112",
      },
      {
        internalType: "uint32",
        name: "unstakeDelaySec",
        type: "uint32",
      },
      {
        internalType: "uint48",
        name: "withdrawTime",
        type: "uint48",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "getDepositInfo",
    outputs: [
      {
        components: [
          {
            internalType: "uint112",
            name: "deposit",
            type: "uint112",
          },
          {
            internalType: "bool",
            name: "staked",
            type: "bool",
          },
          {
            internalType: "uint112",
            name: "stake",
            type: "uint112",
          },
          {
            internalType: "uint32",
            name: "unstakeDelaySec",
            type: "uint32",
          },
          {
            internalType: "uint48",
            name: "withdrawTime",
            type: "uint48",
          },
        ],
        internalType: "struct IStakeManager.DepositInfo",
        name: "info",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "uint192",
        name: "key",
        type: "uint192",
      },
    ],
    name: "getNonce",
    outputs: [
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "initCode",
        type: "bytes",
      },
    ],
    name: "getSenderAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "initCode",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "callGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "verificationGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preVerificationGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "paymasterAndData",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct UserOperation",
        name: "userOp",
        type: "tuple",
      },
    ],
    name: "getUserOpHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "sender",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
              },
              {
                internalType: "bytes",
                name: "initCode",
                type: "bytes",
              },
              {
                internalType: "bytes",
                name: "callData",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "callGasLimit",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "verificationGasLimit",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "preVerificationGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxPriorityFeePerGas",
                type: "uint256",
              },
              {
                internalType: "bytes",
                name: "paymasterAndData",
                type: "bytes",
              },
              {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
              },
            ],
            internalType: "struct UserOperation[]",
            name: "userOps",
            type: "tuple[]",
          },
          {
            internalType: "contract IAggregator",
            name: "aggregator",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct IEntryPoint.UserOpsPerAggregator[]",
        name: "opsPerAggregator",
        type: "tuple[]",
      },
      {
        internalType: "address payable",
        name: "beneficiary",
        type: "address",
      },
    ],
    name: "handleAggregatedOps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "initCode",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "callGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "verificationGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preVerificationGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "paymasterAndData",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct UserOperation[]",
        name: "ops",
        type: "tuple[]",
      },
      {
        internalType: "address payable",
        name: "beneficiary",
        type: "address",
      },
    ],
    name: "handleOps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint192",
        name: "key",
        type: "uint192",
      },
    ],
    name: "incrementNonce",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "callData",
        type: "bytes",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "sender",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "callGasLimit",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "verificationGasLimit",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "preVerificationGas",
                type: "uint256",
              },
              {
                internalType: "address",
                name: "paymaster",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxPriorityFeePerGas",
                type: "uint256",
              },
            ],
            internalType: "struct EntryPoint.MemoryUserOp",
            name: "mUserOp",
            type: "tuple",
          },
          {
            internalType: "bytes32",
            name: "userOpHash",
            type: "bytes32",
          },
          {
            internalType: "uint256",
            name: "prefund",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "contextOffset",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preOpGas",
            type: "uint256",
          },
        ],
        internalType: "struct EntryPoint.UserOpInfo",
        name: "opInfo",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "context",
        type: "bytes",
      },
    ],
    name: "innerHandleOp",
    outputs: [
      {
        internalType: "uint256",
        name: "actualGasCost",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint192",
        name: "",
        type: "uint192",
      },
    ],
    name: "nonceSequenceNumber",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "initCode",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "callGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "verificationGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preVerificationGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "paymasterAndData",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct UserOperation",
        name: "op",
        type: "tuple",
      },
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "targetCallData",
        type: "bytes",
      },
    ],
    name: "simulateHandleOp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "sender",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "initCode",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "callGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "verificationGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preVerificationGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "bytes",
            name: "paymasterAndData",
            type: "bytes",
          },
          {
            internalType: "bytes",
            name: "signature",
            type: "bytes",
          },
        ],
        internalType: "struct UserOperation",
        name: "userOp",
        type: "tuple",
      },
    ],
    name: "simulateValidation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unlockStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "withdrawAddress",
        type: "address",
      },
    ],
    name: "withdrawStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "withdrawAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "withdrawAmount",
        type: "uint256",
      },
    ],
    name: "withdrawTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type EntryPointConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: EntryPointConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class EntryPoint__factory extends ContractFactory {
  constructor(...args: EntryPointConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<EntryPoint> {
    return super.deploy(overrides || {}) as Promise<EntryPoint>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): EntryPoint {
    return super.attach(address) as EntryPoint;
  }
  override connect(signer: Signer): EntryPoint__factory {
    return super.connect(signer) as EntryPoint__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): EntryPointInterface {
    return new utils.Interface(_abi) as EntryPointInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): EntryPoint {
    return new Contract(address, _abi, signerOrProvider) as EntryPoint;
  }
}
